module.exports = __webpack_public_path__ + "ipetbooking-landing/img/interface07@1.cef69a23.png";